module.exports = __webpack_public_path__ + "img/hr-V-L-4-unload-connect.618fd421.png";